import { useEffect } from 'react'

interface SEOProps {
  title: string
  description: string
  keywords?: string
  noindex?: boolean
  ogTitle?: string
  ogDescription?: string
  ogType?: string
}

export function useSEO({
  title,
  description,
  keywords,
  noindex = false,
  ogTitle,
  ogDescription,
  ogType = 'website',
}: SEOProps) {
  useEffect(() => {
    // Title
    document.title = title

    // Helper to set or create meta tag
    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name'
      let el = document.querySelector(
        `meta[${attr}="${name}"]`,
      ) as HTMLMetaElement
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute(attr, name)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    }

    setMeta('description', description)
    if (keywords) setMeta('keywords', keywords)
    setMeta('robots', noindex ? 'noindex, nofollow' : 'index, follow')

    // Open Graph
    setMeta('og:title', ogTitle || title, true)
    setMeta('og:description', ogDescription || description, true)
    setMeta('og:type', ogType, true)
    setMeta('og:site_name', 'ellnerconsultancy', true)

    // Twitter Card
    setMeta('twitter:card', 'summary_large_image')
    setMeta('twitter:title', ogTitle || title)
    setMeta('twitter:description', ogDescription || description)
  }, [title, description, keywords, noindex, ogTitle, ogDescription, ogType])
}
